import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setAuthenticated, setBuyer } from "../../../redux/slices/authSlice";
import { getCurrentBuyer } from "./services/authServices";
import ErrorText from "../../../components/ErrorText";
import AuthCard from "../../../components/AuthCard";

export default function GoogleCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const error = params.get("error");

    if (error === "email_exists") {
      setErrorMessage(t("emailAlreadyRegistered"));
      setTimeout(() => navigate("/auth/sign-in"), 3000);
      return;
    }

    if (!token) {
      navigate("/auth/sign-in?error=google_failed");
      return;
    }

    localStorage.setItem("jwtToken", token);

    getCurrentBuyer(token)
      .then((buyer) => {
        localStorage.setItem("buyer", JSON.stringify(buyer));
        dispatch(setBuyer(buyer));
        dispatch(setAuthenticated(true));
        navigate("/dashboard");
      })
      .catch(() => {
        navigate("/auth/sign-in?error=google_fetch");
      });
  }, [dispatch, location.search, navigate, t]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <h2 className="main-header mb-4 text-center">
          {t("signingInWithGoogle")}
        </h2>
        {errorMessage && <ErrorText>{errorMessage}</ErrorText>}
      </AuthCard>
    </div>
  );
}
